module.exports = __webpack_public_path__ + "img/axis.d2af1876.png";